<style>
.center {
  display: block;
  margin: auto;
  width: 60%;

  /* border: 3px solid green; */
}

.footer-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.container-total {
  display: flex;
  justify-content: center;
  gap: .5rem;
}

.container-total > span {
  font-weight: bolder;
  font-size: 16px;
  color: #343a40;
}

@media (max-width: 740px) {
  .footer-table {
    flex-direction: column-reverse;
    gap: .5rem;
  }
}
</style>


<template>
    <div class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8" >
        <div>
            <img class="mx-auto h-20 w-auto" :src="ImgSrc" alt="Workflow" />
            <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900" v-if="!mostrarTabla">INGRESE SU CUIL</h2>
            <div v-else-if="tablaVacia">

              <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900" >CUOTAS PENDIENTES</h2>

            </div>
            <div v-else>

              <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900" >USTED ESTA AL DIA CON SUS CUOTAS</h2>

            </div>
            
            
            
        </div>
        <form class="mt-8 space-y-6" @submit.prevent="buscarBoletas" v-if="!mostrarTabla">
            <input type="hidden" name="remember" value="true" />
            <div class="rounded-md shadow-sm -space-y-px">
            <div>
                <label for="email-address" class="block text-sm font-medium">Cuil</label>
                <input autofocus v-model="cuilAfi" id="email-address" name="Cuil" type="number" autocomplete="username" required="" class="mt-1 appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="XX000000000X" 
                onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 13 ? false : true "
                />
            </div>
            
            </div>

            <div>
            <button type="submit" v-show="cuilAfi.toString().length == 11" :class="{ 'cursor-not-allowed': loading }" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-iosep-blue to-iosep-green hover:to-iosep-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" :disabled="loading">
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                <SearchIcon v-if="!loading" class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" />
                <div v-else>
                    <svg role="status" class="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                </div>
                </span>
                Buscar boletas
            </button>

            <transition-group name="p-message" tag="div">
                <Message v-for="msg of messages" :life="5000" severity="error" :key="msg.id">{{msg.content}}</Message>
            </transition-group>

            </div>
        </form>


        


        </div>
    </div>

        <div class="center" v-if="mostrarTabla">
          <DataTable :value="comprobantes" v-if="tablaVacia">
              <Column field="periodo" header="Periodo"></Column>
              <Column field="numero" header="N° Comprobante">
                <template #body="{ data }">{{ data.numero.replace(/[^0-9]/g, '') }}</template>
              </Column>
              <Column field="importe" header="Importe">
                <template #body="{ data }">{{ data.importe.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) }}</template>
              </Column>
          </DataTable>  
          <div class="footer-table">
              <Button label="Ver comprobante" icon="pi pi-search" @click="imprimirComprobante(ComprobanteImprimir())"/>
              <div class="container-total">
                <span>Total:</span> 
                <span>{{ importeTotal }}</span>
              </div>
          </div>  

          <div class="group relative w-full flex justify-center">          
            <Button label="Cambiar Cuil" @click="refreshPage" class="p-button-outlined p-button-secondary" icon="pi pi-search"/>
          </div>




        </div>


        <Dialog v-model:visible="data.modales.imprimir" header="  " maximizable modal :breakpoints="{'1000px': '75vw', '700px': '90vw'}" :style="{width: '50vw'}" :position="position" >

          <div class="flex flex-wrap shadow-xl">
            <div class="m-4">
              <Button label="Imprimir" icon="pi pi-print" class="p-button-outlined p-button-secondary" @click="openPDF('print')" />
            </div>
            <div class="m-4">
              <Button label="Descargar" icon="pi pi-download" class="p-button-outlined p-button-secondary" @click="openPDF('download')" />
            </div>
            <div class="m-4">
              <Button label="Pagar" icon="pi pi-pi-money-bill" class="p-button-outlined p-button-secondary" @click="pagarBono(ComprobanteImprimir())" />
            </div>
          </div>
          <div class="flex justify-end flex-wrap shadow-xl">
            <div class="m-4">
              <Button icon="pi pi-search-minus" class="p-button-rounded p-button-secondary p-button-outlined" @click="data.modales.zoom -= 100" :disabled="data.modales.zoom < 500"  />
            </div>
            <div class="m-4">
              <Button icon="pi pi-search-plus" class="p-button-rounded p-button-secondary p-button-outlined" @click="data.modales.zoom += 100" :disabled="data.modales.zoom > 3000" />
            </div>
          </div>
          <div class="flex mt-4 justify-center">

          <vue-pdf-embed :source="pdfSource" :height="data.modales.zoom" />

          </div>
        </Dialog>

        
    
</template>

<script>
  import { ref, computed, reactive } from 'vue';
  import { DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
  import { ExclamationIcon } from '@heroicons/vue/outline';
  import { LockClosedIcon, EyeIcon, EyeOffIcon, SearchIcon } from '@heroicons/vue/solid'
  import Message from 'primevue/message';


  import axios from 'axios'
  import WService from '@/plugins/ws';
  import VuePdfEmbed from "vue-pdf-embed";

  //Imports para TABLA
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import ColumnGroup from 'primevue/columngroup';   // optional
  import Row from 'primevue/row'; 
  import Card from 'primevue/card';
  import Button from 'primevue/button';
  import Dialog from 'primevue/dialog'; 
  //end Imports para TABLA

  import printJS from 'print-js'




export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    LockClosedIcon,
    EyeIcon,
    EyeOffIcon,
    ExclamationIcon,
    SearchIcon,
    DataTable,
    Column,
    ColumnGroup,
    Row,
    Message,
    Card,
    Button,
    VuePdfEmbed
},
  setup() {

    const cuilAfi = ref('');
    const load = ref(false);
    const wService = ref(new WService());

    const open = ref(false);
    const loading = ref(false);
    const messages = ref([]);

    const ImgSrc = require(`@/assets/logo_iosep.png`);
    //Comprobantes
    const comprobantes = ref();
    const pdfSource = ref("");

    //imprimir
    const nombreArchivo = ref("");

    const importeTotal = computed(() => {
      let total = comprobantes.value[comprobantes.value.length - 1]
      let importe = comprobantes.value.length > 0 ? total.importe : 0
      const formattedNumber = importe.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
      return formattedNumber;
    });


    function ComprobanteImprimir(){
      const lastElementId = comprobantes.value.length - 1; // get the index of the last element
      const lastElement = comprobantes.value[lastElementId]; // get the last element using the index
      return lastElement;
    };


    const tablaVacia = computed(() => {
      return typeof comprobantes.value !== "undefined" && comprobantes.value.length > 0;
    });

    const cuilValido = computed(() => {
      return cuilAfi.value.length === 11 ;
    });    
    
    const data = reactive({
        desde: null,
        hasta: null,
        save: {
          esEmpresa: false,
        },
        modales: {
          viejo: false,
          movimiento: false,
          imprimir: false,
          urlImprimir: '',
          zoom: 900
        },
        idAfiliado: 0,
        idEmpresa: 0,
        empresasFiltradas: [],
        errors: {},
        newReg: false,
        showCtaCte: false,
      });

      const setModal = (modal, open) => {
        data.modales[modal] = open;
      }

    const showModal = (name) => {
      open.value = true;
    }

    const mostrarTabla = ref(false);

    function buscarBoletas(){

      loading.value = true;
      let dataSend = { cuil: cuilAfi.value };

      var config = {
        url: "Autogestion/Boleta",
        method:"GET",
        headers: { 'Content-Type': 'application/json',},
        params: dataSend
      };

      axios(config).then(function (response) {
        // console.log(JSON.stringify(response.data));
        comprobantes.value = response.data;
        mostrarTabla.value = true;
      })
      .catch(error => {
        mostrarTabla.value = false;
        console.error(error);
        if (error.response.status == 500) {
        messages.value.push({
              
              content: "El cuil no se encuentra registrado en iosep"
            });
        }
        else{
          messages.value.push({
            content: "Ocurrio un error al querer obtener las boletas"
            });
        }
      })

      loading.value = false;
    }

    //para traer el pdf.
    function imprimirComprobante(data) {
        const idComp = data.idComprobante;
        load.value = true;

        wService.value.pdfMethod("Comprobantes/Imprimir/" + idComp).then(info => {
          nombreArchivo.value = 'Archivo CtaCte';
          var newBlob = new Blob([info.data], { type: "application/pdf" })
          const url = window.URL.createObjectURL(newBlob);
          data.urlImprimir = url;
          pdfSource.value = url;

          load.value = false;
          setModal("imprimir", true)
        }).catch(err => {
          load.value = false;
          console.error(err.message);
        });
      }

      function refreshPage() {
      window.location.reload();
    }

    // Este metodo es para mantener la pagina anterior y redirigir a la nueva.
    const navigateToUrl = (url) => {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

      //para imprimir o descargar pdf.
      const openPDF = (type) => {

        switch (type) {
          case "print":
            printJS(pdfSource.value)
            break;
          case "download":
            window.open(pdfSource.value);
            break;
        }
      }

      const pagarBono = (comp) => {
        const idComp = comp.idComprobante.toString(); 
        const codbar = comp.codigoBarra.toString();
        const dataSend = {
          monto: comp.importe,
          clienteId: comp.idAfiliado,
          // transaccionId: `I${idComp}`,
          transaccionId: `G${codbar}`,
          referencia: comp.numero,
          mail: comp.email
        }

        var config = {
          url: "https://pay.iosep.gob.ar/apipago/api/Objetos/GenerateUrl",
          method:"GET",
          headers: { 'Content-Type': 'application/json',},
          params: dataSend
        };

        axios(config).then(function (response) {
          const URLPago = response.data.url
          navigateToUrl(URLPago); 
        })
        .catch(error => {
          console.error(error);

          messages.value.push({
            content: "Ocurrio un error al querer obtener el URL de pago"
          });
        })
      }

    return {
      data,
      cuilAfi,
      importeTotal,
      ComprobanteImprimir,
      tablaVacia,
      load,
      pdfSource,
      cuilValido,

      open,
      loading,
      messages,
      ImgSrc,

      comprobantes,
      mostrarTabla,
      nombreArchivo,
      
      imprimirComprobante,
      buscarBoletas,
      showModal,
      openPDF,
      refreshPage,
      pagarBono
    }
  }
}
</script>

